module.exports = __webpack_public_path__ + "static/img/3.533d059.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/1/12/sp/3.png
// module id = 8hTh
// module chunks = 0